import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
import * as moment from 'moment';
import { CollaboratorsSelectExtendsComponent } from 'src/app/collaborator/collaborators/collaborators-select-extends/collaborators-select-extends.component';
import { constants } from 'src/app/constants';
import { BookingsExtendsComponent } from '../../bookings/bookings-extends/bookings-extends.component';
declare var $: any;

@Component({
  selector: 'app-arrivals-list',
  templateUrl: './arrivals-list.component.html',
  styleUrls: ['./arrivals-list.component.css']
})
export class ArrivalsListComponent implements OnInit {
  private thisComponent: ArrivalsListComponent;
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(BookingsExtendsComponent) BookingsExtendsComponent: any;
  @ViewChild(SearchComponent) searchComponent: any;
  @ViewChild(CollaboratorsSelectExtendsComponent) CollaboratorsSelectExtendsComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  start_range:any = moment();
  end_range:any = moment().endOf('month');
  date_now:any = moment().format('YYYY-MM-DD');

  total_pax: number = 0;
  groupedBookings: any;

  arrival_cuentapropia:any = constants.TOURISM.ARRIVAL_BOOKING[4];

  constructor(
    private routeActivated: ActivatedRoute,
    private router: Router,
    private bookingsService: BookingsService,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService,
    private elementRef: ElementRef
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  
  ngOnInit() {
    // let component_ = this.thisComponent;
    // (<any>$('#date_range')).daterangepicker({
    //   locale: {
    //     format: 'YYYY-MM-DD'
    //   },
    //   startDate: component_.start_range,
    //   endDate: component_.end_range,
    //   showDropdowns: true,
    // },
    //   function(start_date: any, end_date: any) {
    //     component_.start_range = start_date;
    //     component_.end_range = end_date;
    //     component_.list();
    //   }  
    // );
    this.generateCalendar();
    this.list();
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    
  }

  generateCalendar(){
    let component_ = this.thisComponent;
    (<any>$('#date_range')).daterangepicker({
      locale: {
        format: 'YYYY-MM-DD'
      },
      startDate: component_.start_range,
      endDate: component_.end_range,
      showDropdowns: true,
    },
      function(start_date: any, end_date: any) {
        component_.start_range = start_date;
        component_.end_range = end_date;
        component_.list();
      }  
    );
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page+
    "&start_range=" + this.start_range.format('YYYY-MM-DD') + '&end_range=' + this.end_range.format('YYYY-MM-DD');
    this.bookingsService.listArrivals(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        // this.dataPagination.pageSize = data.paginate_by;
        // this.dataPagination.currentPage = this.page;
        // this.dataPagination.totalItems = data.total;
        this.total_pax = 0;
        for (let index in this.items) {
          let item_ = this.items[index];
          this.total_pax = this.total_pax + item_.nro_pax;
        }

        this.groupBookingsByDate(this.items);
        setTimeout(() => {
          (<any>$('[data-toggle="tooltip"]')).tooltip();
        }, 500);
      }
    });
  }

  groupBookingsByDate(bookings: any[]) {
    // this.groupedBookings = bookings.reduce((acc, booking) => {
    //   const date = booking.date_arrival;
    //   if (!acc[date]) {
    //     acc[date] = [];
    //   }
    //   acc[date].push(booking);
    //   return acc;
    // }, {});
    this.groupedBookings = bookings.reduce((acc, booking) => {
      const date = booking.date_arrival;    
      // Si no existe la fecha en el acumulador, inicializamos
      if (!acc[date]) {
        acc[date] = {
          bookings: [],
          totalNroPax: 0, // Inicializamos el contador de nro_pax
        };
      }
    
      // Agregar el booking al array correspondiente
      acc[date].bookings.push(booking);
    
      // Sumar el nro_pax del booking actual al total
      acc[date].totalNroPax += booking.nro_pax;
    
      return acc;
    }, {});
  }

  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.start_range = moment();
    this.end_range = moment().endOf('month');
    this.ngOnInit();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reservas/recibidos/editar',
      id
    ]);
  }

  detail(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reservas/recibidos/detalle',
      id
    ]);
  }

  pickupHotel(book:any){
    let options = {
      title: 'DELEGAR RECOJO HOTEL',
      message: "¿Esta seguro(a) en asignar el recojo de la reserva N° "+book.code+" a cargo del hotel?",
      cancel: 'Cancelar',
      confirm: 'SÍ, ASIGNAR RECOJO'
    };
    this.alert.confirmInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        this.bookingsService.pickupHotel(book.id, book).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success("RECOJO PROGRAMADO con éxito !");
            this.list();
          }
        });
      }
    });
  }

  pickupCollaborator(book:any){
    this.CollaboratorsSelectExtendsComponent.init(book);
  }

  selectedCollaborator(data:any){
    let book:any = data.book;
    book.pickup_collaborator_id = data.collaborator.id;    
    this.bookingsService.pickupCoolaborator(book.id, book).subscribe({
      next: (data: any) => {
        this.alertifyMsg.success("RECOJO PROGRAMADO con éxito !");
        this.list();
      }
    });
  }

  resetPickup(book:any){
    this.bookingsService.resetPickup(book.id, book).subscribe({
      next: (data: any) => {
        this.alertifyMsg.success("Se ha quitado los datos del recojo!");
        this.list();
      }
    });
  }

  copyToClipboard(book_id:any){
    let generatedData = this.elementRef.nativeElement.querySelector('#generated-data-'+book_id).innerText;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(generatedData)
        .then(() => {
          console.log('Copied to clipboard');
        })
        .catch(err => {
          console.error('Failed to copy: ', err);
          // Handle clipboard write error (e.g., show error message to user)
        });
    } else {
      // Fallback for browsers that do not support navigator.clipboard
      this.copyFallback(generatedData);
    }
  }

  detailBookingExtends(booking: any) {
    this.BookingsExtendsComponent.init(booking.id);
  }

  afterBookingDetail(data: any) {

  }

  copyFallback(text: string) {
    // Fallback method for unsupported browsers
    const textarea = document.createElement('textarea');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      document.execCommand('copy');
      // console.log('Copied to clipboard using fallback');
      this.alertifyMsg.success("DATOS COPIADOS");
      // Optionally, provide user feedback (e.g., toast notification)
    } catch (err) {
      console.error('Fallback: Unable to copy to clipboard', err);
      // Handle fallback copy error (e.g., show error message to user)
    } finally {
      document.body.removeChild(textarea);
    }
  }
}
